function CompositeField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, FormService, $q, Classes) {
			var self = this;

			
			
			
			if (!this.object[this.field.name]) {
                this.object[this.field.name] = {};
                
			}
			/*
			if (!this.object[this.field.name].__parent) {
				Object.defineProperty(this.object[this.field.name], '__parent', {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: self.object
                });
			}
			*/

			this.object[this.field.name].__parent = {}

			if (this.object.__class) {
				self.Class = Classes[this.object.__class];
				$scope.$watchCollection(function(){return self.object}, function(value) {
					if (!value) return;
					self.object[self.field.name].__parent = self.Class.getObjectPayload(value, 'essential');
				});
			}
			
			
			//this.subfields = this.object.get_form_params(this.field.client.fields)
			

		},
		controllerAs: '$ref'
	}
}


angular.module('forms.fields.composite', [])
.directive('compositeField', CompositeField)